import dynamic from 'next/dynamic';
import { SearchAndFilterProps } from './SearchAndFilter.types';

export const SearchAndFilter = dynamic<{ model: SearchAndFilterProps }>(() =>
  import('./SearchAndFilter').then(mod => mod.SearchAndFilter)
);
